import { DynamicObjectInterface } from '../../sdk/type';

export const HasSpecialCharacters = (input: string) => {
  const specialCharsRegex = /[!#$%^&*(),;'"/?{}|<>[\]`~]/;
  return specialCharsRegex.test(input);
};

export const validateNoSpecialCharacter = (input: string) => {
  const regex = /^[a-zA-Z0-9\s]+$/;
  return regex.test(input);
};

// Video/audio formats for assessment uploads (MP4, MOV, WAV). `.mov` reports as
// video/quicktime; WAV can be reported under a few different MIME strings.
export const VIDEO_FILE_TYPES = [
  'video/mp4',
  'video/quicktime',
  'audio/wav',
  'audio/x-wav',
  'audio/wave',
  'audio/vnd.wave',
];

export const validateAttachment = (
  e: DynamicObjectInterface,
  t: Function,
  fileSizeLimit: number,
  // Extra MIME types to allow on top of the default image/pdf set. Pass
  // VIDEO_FILE_TYPES from the pre/post-assessment upload; leave empty elsewhere
  // (check-in, admin) so those keep accepting images/PDF only.
  extraFileTypes: string[] = [],
  // Separate (usually larger) size cap in MB for video/audio files. Video proof
  // clips are bigger than photos, so the assessment upload allows more for them.
  // Defaults to fileSizeLimit, so callers that don't set it keep one shared limit.
  videoFileSizeLimit: number = fileSizeLimit,
) => {
  const VALID_FILE_TYPES = [
    'image/jpeg',
    'image/jpg',
    'image/svg+xml',
    'image/png',
    'image/tiff',
    'image/gif',
    'application/pdf',
    ...extraFileTypes,
  ];

  if (
    e?.target &&
    ((e?.target?.files && e?.target?.files?.length > 0) ||
      (e?.dataTransfer?.files && e?.dataTransfer?.files?.length > 0))
  ) {
    const file = e.target.files || e.dataTransfer.files;
    // Video/audio files get the larger cap; everything else uses the base limit.
    const isVideoOrAudio = VIDEO_FILE_TYPES.includes(file[0].type);
    const maxFileSize = (isVideoOrAudio ? videoFileSizeLimit : fileSizeLimit) * 1024 * 1024;
    const isFileSizeValid = file[0].size <= maxFileSize; // Valid File Size
    const isFileTypeValid = VALID_FILE_TYPES.includes(file[0].type); // Valid File Type

    let message = '';
    if (!isFileSizeValid && !isFileTypeValid) {
      message = t('dashboard.api-message.common.invalidFileAndExceedLimit');
    } else if (!isFileSizeValid && isFileTypeValid) {
      message = t('dashboard.api-message.common.fileExceedsLimit');
    } else if (isFileSizeValid && !isFileTypeValid) {
      message = t('dashboard.api-message.common.invalidFileType');
    }
    const isFileValid = isFileSizeValid && isFileTypeValid;

    return { status: isFileValid, message };
  }
};
